import PDFTablePage from '../../../themed/pdf/pdfTablePage';
import classNames from '../pdf.module.scss';

import * as data from '../../../../utils/data';
import * as models from '../../../../utils/models';

const ETSummarySheet = (props: models.ETSummarySheetData): JSX.Element => {
	const getDangeHeaderClassName = (): string => {
		return classNames['visual-inspection-body-header-danger'];
	};

	return (
		<div className={classNames['visual-inspection']}>
			<div className={classNames['visual-inspection-body']}>
				<div className={classNames['visual-inspection-body-header']}>
					Summary
				</div>
				<div className={classNames['visual-inspection-body-body']}>
					<p>{props.general}</p>
				</div>
			</div>
			<div className={classNames['visual-inspection-body']}>
				<div className={getDangeHeaderClassName()}>
					Remarks & Recommendations:
				</div>
				<div className={classNames['visual-inspection-body-body']}>
					<p>{props.remarks}</p>
				</div>
			</div>

			<div className="border-horizontal-light">
				<PDFTablePage
					columns={data.getinspectionItemTableColumns()}
					data={props.inspectedItems ?? []}
				/>
			</div>
		</div>
	);
};

export default ETSummarySheet;
